import React from 'react';
import { Flex } from '@withjoy/joykit';

import { LazyBookingsTabLegacy } from './BookingsTabLegacy.lazy';
import { useGuestStaysCanvasMode } from '../GuestStaysDashboard/useGuestStaysCanvasMode';
import { LazyGuestStaysDashboard } from '../GuestStaysDashboard/GuestStaysDashboard.lazy';
import { GuestStaysDashboardSkeleton } from '../GuestStaysDashboard/GuestStaysDashboard.skeleton';

// Renders the new Guest Stays dashboard or legacy bookings tab behind the feature flag.
export const BookingsTab: React.FC = () => {
  const { isDashboardEnabled, isFlagLoading } = useGuestStaysCanvasMode();

  // Shows a loading skeleton without extra horizontal padding while checking the flag.
  if (isFlagLoading) {
    return (
      <Flex
        flexDirection="column"
        paddingTop={4}
      >
        <GuestStaysDashboardSkeleton />
      </Flex>
    );
  }

  return isDashboardEnabled ? <LazyGuestStaysDashboard /> : <LazyBookingsTabLegacy />;
};
